import { AdEnginePlugin, type Hooks } from "./../../core/AdEnginePlugin";
import type { GptWrapper } from "./../../core/GptWrapper";

/**
 * PerformanceTestPlugin is responsible for setting up marker when top_leaderboard is rendered.
 * It uses GPT slotRenderEnded event and marks "top_leaderboard_rendered" using native Performance API.
 */
export class PerformanceTestPlugin extends AdEnginePlugin {
  hooks: Hooks = {
    onBeforeFirstCallAdsRequest(gpt: GptWrapper) {
      gpt.addEventListener("slotRenderEnded", (eventPayload) => {
        if (eventPayload.slot.getSlotElementId() === "top_leaderboard") {
          performance.mark("top_leaderboard_rendered");
        }
      });
    },
  };
}
